const correioAPI = async (cep) => {
    let attempts = 0;
    while (attempts < 3) {
        try {
            const url = `https://us-central1-correios-api-99b69.cloudfunctions.net/correiosAPI/prazo?cep_destino=${cep}`
            const response = await fetch(url)
            if (!response.ok) throw new Error("Ops, algo deu errado. Tente novamente mais tarde.");
            const data = await response.json()
            return data
        } catch (e) {
            attempts++;
            await new Promise(resolve => setTimeout(resolve, 600)) // Add a delay of 600ms
        }
    }
    throw new Error("Ops, algo deu errado. Tente novamente mais tarde.");
}

const handleZipCode = (event) => {
    let input = event.target
    input.value = zipCodeMask(input.value)
}

const zipCodeMask = (value) => {
    if (!value) return ""
    value = value.replace(/\D/g, '')
    value = value.replace(/(\d{5})(\d)/, '$1-$2')
    return value
}

const calcularFrete = async ({ event, stock, prazo_de_producao }) => {
    const container = document.querySelector("#consultar-prazo")
    const button = container.querySelector("button")
    const input = container.querySelector("input")
    const result = container.querySelector("#result")
    const error = container.querySelector("#error")
    const initialText = button.innerHTML
    button.innerHTML = `<i class="fa-solid fa-circle-notch fa-spin"></i>`
    try {
        event.preventDefault()
        const cep = input.value
        let dataTotal = false;
        if (!cep) {
            button.innerHTML = initialText
            return error.innerHTML = "Digite um CEP válido"
        }
        const cepSanitized = cep.replace(/\D/g, '')
        const data = await correioAPI(cepSanitized)
        if (data.error) {
            button.innerHTML = initialText
            return error.innerHTML = data.error
        }
        if (stock <= 0) {
            dataTotal = luxon.DateTime.fromISO(data.prazo).plus({ days: prazo_de_producao }).setLocale('pt-BR').toFormat('cccc, dd LLL yyyy');
        }
        const dataFormatada = dataTotal ? dataTotal : luxon.DateTime.fromISO(data.prazo).setLocale('pt-BR').toFormat('cccc, dd LLL yyyy');
        button.innerHTML = initialText
        return result.innerHTML = `<span style="font-size: 14px;">Prazo estimado:</span><br><span style="color:#00a650">Chegará GRÁTIS</span> até <b>${dataFormatada}</b> em seu endereço`
    } catch (err) {
        error.innerHTML = "Erro ao consultar prazo. Tente novamente mais tarde."
        button.innerHTML = initialText
        console.error(err)
    }
}